import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const assetCardGroupFn = /* @__PURE__ */ createRecipe('AssetCardGroup', {}, [])

const assetCardGroupVariantMap = {}

const assetCardGroupVariantKeys = Object.keys(assetCardGroupVariantMap)

export const assetCardGroup = /* @__PURE__ */ Object.assign(memo(assetCardGroupFn.recipeFn), {
  __recipe__: true,
  __name__: 'assetCardGroup',
  __getCompoundVariantCss__: assetCardGroupFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: assetCardGroupVariantKeys,
  variantMap: assetCardGroupVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, assetCardGroupVariantKeys)
  },
  getVariantProps: assetCardGroupFn.getVariantProps,
})